import React from 'react';
import classNames from 'classnames';
import { incBaseIdentity, incBase } from '../../../helpers/paths';
import style from './index.module.scss';
import Nav from '.';
import { jsx as _jsx } from "react/jsx-runtime";

const Account = _ref => {
  let {
    from = '',
    redirect,
    user,
    onClose
  } = _ref;
  const path = redirect || "".concat(location.pathname).concat(location.search).concat(location.hash);
  const searchParams = new URLSearchParams({
    path
  });

  if (from !== '') {
    searchParams.append('from', from);
  }

  if (path.startsWith('/account/') || path.startsWith('/account-info')) {
    searchParams.set('path', '/');
  }

  const logoutUrl = "".concat(incBaseIdentity('logout'), "?").concat(searchParams.toString());
  const items = [() => /*#__PURE__*/_jsx("div", {
    className: classNames(style.item, style['item-big']),
    "data-test-id": "main-navdrawer-welcome-message",
    "data-id": "nav_account_items_div",
    children: user !== null && user !== void 0 && user.firstName ? "Hi, ".concat(user === null || user === void 0 ? void 0 : user.firstName, "!") : 'Hi!'
  }), {
    label: 'Account',
    url: incBase("account-info")
  }, {
    label: 'Orders',
    url: incBase("account-info/orders")
  }, {
    label: 'Payment methods',
    url: incBase("account-info/payment-methods")
  }, {
    label: 'Sign out',
    url: logoutUrl
  }];
  return /*#__PURE__*/_jsx(Nav, {
    className: classNames(style['nav-reverse']),
    items: items,
    onClose: onClose,
    "data-id": "nav_account_items_Nav"
  });
};

export default Account;